import { render, staticRenderFns } from "./ProductCategorySelector.vue?vue&type=template&id=d2e233ec&"
import script from "./ProductCategorySelector.ts?vue&type=script&lang=ts&"
export * from "./ProductCategorySelector.ts?vue&type=script&lang=ts&"
import style0 from "./ProductCategorySelector.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QSelect} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSelect})
